import _TemplatedMixin from "dijit/_TemplatedMixin";
import _WidgetBase from "dijit/_WidgetBase";
import declare from "dojo/_base/declare";

const templateString = `
<div>
<span data-dojo-attach-point="hintMessageNode">\$\{StartSearch:_nls\}</span>
</div>
`;

const DelayFilteringPlaceholder = declare([_WidgetBase, _TemplatedMixin], {
	baseClass: "csi-combo-box-filtering-hint-placeholder",
	templateString,

	// attach points
	hintMessageNode: null,

	/** this is needed to satisfy Typescript - I guess "_set" is not part of the _WidgetBase typings */
	_set(attr: string, value: any) {
		this.inherited(arguments);
	},
});

export = DelayFilteringPlaceholder;